import {Amenity, Room} from '@findhotel/sapi'

import {IconName} from '@vio/atlas/src/components/designSystem/Icon'

import {RANKED_AMENITIES, RANKED_AMENITY_CATEGORIES} from './constants'

export type AmenitiesGroup = {
  category: Amenity['category']
  categoryId: Amenity['categoryId']
  categoryIcon: IconName
  amenities: Room['amenitiesList']
}

export const rearrangeAmenitiesByRankedCategory = (
  amenities: Room['amenitiesList'] | undefined
): AmenitiesGroup[] => {
  return RANKED_AMENITY_CATEGORIES.reduce<AmenitiesGroup[]>((acc, current) => {
    const categoryAmenities =
      amenities?.filter(amenity => amenity.categoryId === current.id) || []

    const newGroup = categoryAmenities.length
      ? [
          {
            category: categoryAmenities[0].category,
            categoryId: categoryAmenities[0].categoryId,
            categoryIcon: current.icon,
            amenities: categoryAmenities
          }
        ]
      : []

    return [...acc, ...newGroup]
  }, [])
}

export const getTopRoomAmenities = (amenitiesList: Room['amenitiesList']) => {
  if (!amenitiesList || amenitiesList.length === 0) {
    return []
  }

  const tierLimits = [2, 3, 2] // Tier 1: 2, Tier 2: 3, Tier 3: 2

  const tierMatches = RANKED_AMENITIES.map((tier, tierIndex) =>
    tier.reduce((matches: Array<Amenity & {icon: IconName}>, rankedAmenity) => {
      const matchedAmenity = amenitiesList.find(
        amenity => amenity.id === rankedAmenity.id
      )

      if (matchedAmenity && matches.length < tierLimits[tierIndex]) {
        return [
          ...matches,
          {
            ...matchedAmenity,
            icon: rankedAmenity.icon
          }
        ]
      }

      return matches
    }, [])
  )

  return tierMatches.flat()
}
